import activateLicense from "@api/operations/activate-license";
import { CFC } from "@api/types/cypress";
import Router from "next/router";
import React, { useState } from "react";

import Button from "@components/Button";

const LicenseActivationForm: CFC<{ token: string }> = ({ token, cy }) => {
  const [licenseCode, setLicenseCode] = useState("");
  const [error, setError] = useState(false);

  const activate = async () => {
    const { id } = await activateLicense(token, licenseCode);

    if (!id) {
      setError(true);
    } else {
      await Router.push("/courses/purchased");
    }
  };

  return (
    <>
      <div className="activation-form" data-cy={cy}>
        <input
          type="text"
          value={licenseCode}
          onChange={(e) => {
            setLicenseCode(e.target.value);
          }}
          placeholder="XXXX-XXXX-XXXX-XXXX"
        />
        <Button onClick={() => activate()}>Activate</Button>
        {error && <div className="activation-error">The license code entered is invalid.</div>}
      </div>
      <style jsx>{`
        .container {
          margin-left: 0;
          margin-right: 0;
          padding: 0;
          display: inline-block;
          position: relative;
          width: 100%;
          box-sizing: border-box;
          background-color: rgb(255, 255, 255);
        }

        .activation-container {
          margin-top: 0;
          margin-left: 0;
          padding: 20px 30px;
          display: inline-block;
          position: relative;
          box-sizing: border-box;
          height: auto;
          vertical-align: top;
          width: 100%;
        }

        .activation-header {
          display: block;
          padding-bottom: 24px;
          border-bottom: 1px solid rgb(194, 194, 194);
        }

        .activation-header h2 {
          cursor: default;
          font-size: 24px;
          margin: 0;
          text-align: center;
        }

        .activation-form {
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr;
        }

        .activation-error {
          color: red;
          text-align: left;
          padding-top: 10px;
        }

        input {
          padding-left: 20px;
          height: 49px;
          margin-bottom: 20px;
        }

        @media screen and (min-width: 768px) {
          .activation-form {
            width: 500px;
            display: grid;
            grid-template-columns: 1fr 100px;
            grid-column-gap: 15px;
          }

          input {
            margin-bottom: 0;
          }
        }
      `}</style>
    </>
  );
};

export default LicenseActivationForm;
